var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 5,
    viewBox: "0 0 6 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52456 4.38238C2.76474 4.69439 3.23526 4.69439 3.47544 4.38238L5.72048 1.466C6.0242 1.07146 5.74294 0.5 5.24503 0.5H0.754966C0.257062 0.5 -0.0241952 1.07146 0.279523 1.466L2.52456 4.38238Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArrowDown);
export default __webpack_public_path__ + "static/media/menu-arrow-down.fe482370bc831d25b36e94ba7952b2fc.svg";
export { ForwardRef as ReactComponent };